import React from 'react';
import { API_BASE_URL } from '../../config/api';

function LoginModal({ isOpen, onClose }) {
  const isLocalhost = window.location.hostname === 'localhost' && window.location.port === '5173';

  const handleLogin = async () => {
    try {
      // Store return URL in session
      const returnTo = window.location.pathname + window.location.search;
      await fetch(`${API_BASE_URL}/auth/store-return`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({ returnTo })
      });
      
      // Redirect to Google OAuth
      window.location.href = `${API_BASE_URL}/auth/google`;
    } catch (error) {
      console.error('Error storing return URL:', error);
      // Still redirect to Google OAuth even if storing return URL fails
      window.location.href = `${API_BASE_URL}/auth/google`;
    }
  };

  const handleDevBypass = async () => {
    try {
      // Store return URL in session
      const returnTo = window.location.pathname + window.location.search;
      await fetch(`${API_BASE_URL}/auth/store-return`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({ returnTo })
      });
      
      // Redirect to dev bypass
      window.location.href = `${API_BASE_URL}/auth/dev-bypass`;
    } catch (error) {
      console.error('Error storing return URL:', error);
      // Still redirect to dev bypass even if storing return URL fails
      window.location.href = `${API_BASE_URL}/auth/dev-bypass`;
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/20 backdrop-blur-sm flex items-center justify-center z-50">
      <div className="bg-white/80 backdrop-blur rounded-2xl p-8 max-w-md w-full mx-4 shadow-xl border border-purple-100/30">
        <div className="text-center space-y-4">
          {/* Icon */}
          <div className="w-16 h-16 mx-auto text-purple-500">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/>
            </svg>
          </div>

          {/* Text */}
          <div className="space-y-2">
            <h3 className="text-2xl font-medium text-gray-900 font-fraunces">
              Save books to your shelf
            </h3>
            <p className="text-gray-600 font-space">
              Log in to save your favorite books and build your personal reading collection.
            </p>
          </div>

          {/* Buttons */}
          <div className="space-y-3 pt-2">
            <button
              onClick={handleLogin}
              className="w-full px-4 py-2.5 bg-gradient-to-r from-purple-600 to-blue-500 text-white text-sm font-medium rounded-full hover:from-purple-700 hover:to-blue-600 transition-all shadow-sm font-space flex items-center justify-center gap-2"
            >
              <svg className="w-5 h-5" viewBox="0 0 24 24">
                <path
                  fill="currentColor"
                  d="M21.35 11.1h-9.17v2.73h6.51c-.33 3.81-3.5 5.44-6.5 5.44C8.36 19.27 5 16.25 5 12c0-4.1 3.2-7.27 7.2-7.27 3.09 0 4.9 1.97 4.9 1.97L19 4.72S16.56 2 12.1 2C6.42 2 2.03 6.8 2.03 12c0 5.05 4.13 10 10.22 10 5.35 0 9.25-3.67 9.25-9.09 0-1.15-.15-1.81-.15-1.81z"
                />
              </svg>
              Continue with Google
            </button>
            
            {isLocalhost && (
              <button
                onClick={handleDevBypass}
                className="w-full px-4 py-2.5 bg-gradient-to-r from-green-600 to-emerald-500 text-white text-sm font-medium rounded-full hover:from-green-700 hover:to-emerald-600 transition-all shadow-sm font-space flex items-center justify-center gap-2"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                Dev Bypass (Localhost Only)
              </button>
            )}
            
            <button
              onClick={onClose}
              className="text-gray-600 hover:text-gray-900 text-sm font-medium font-space"
            >
              Maybe later
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginModal; 